export const calculateBarValue = (count: number, total: number) => {
    const share = total !== 0 ? (count / total) * 100 : 0;
    return share === 0 ? 100 : share;
};

export const overviewCardPageSize = 4;

export const eventRowsPerPageOptions = [6, 12, 24, 48];
